<script>
  export let title = "Clients";
  export let subtitle =
    "Join the businesses, governments, non-profit organizations <br>and educational institutions using Curbza";
  export let links = [
    [
      {
        name: "SimplyCast",
        imagePath: "/assets/images/logos/simplycast-logo.png",
        href: "https://www.simplycast.com/",
        css: 'half',
      },
      {
        name: "Black Artists' Network of Nova Scotia (BANNS)",
        imagePath: "/assets/images/logos/banns-logo.png",
        href: "https://www.banns.ca/",
      },
      {
        name: "ISANS - Immigrant Services Association of Nova Scotia",
        imagePath: "/assets/images/logos/isans-logo.png",
        href: "https://www.isans.ca/",
        css: 'half',
      }
    ],
    [
      {
        name: "LearnNorth",
        imagePath: "/assets/images/logos/learnnorth-logo.png",
        href: "https://learnnorth.com/",
      },
      {
        name: "IWK",
        imagePath: "/assets/images/logos/iwk.png",
        href: "https://www.simplycast.com/",
      },
      {
        name: "Pumpkin Village",
        imagePath: "/assets/images/logos/pumpkin-village.jpg",
        href: "https://www.simplycast.com/",
      },
    ]
  ];
</script>

<style>
  #clients {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: "Roboto Medium", Arial, Helvetica, sans-serif;
    padding: 3vw 0;
  }

  #clients .title {
    font-size: 3rem;
  }

  #clients .subtitle {
    text-align: center;
  }

  .row-logos img {
    height: 150px;
    margin-right: 2vw;
  }

  .row-logos img.half {
    height: 75px;
  }

  .row-logos img:not(:last-child) {
    margin-right: 1vw;
  }

  .row-logos img:last-child {
    margin-right: 0;
  }

  /* Small devices (landscape phones, 767px and up) */
  @media (max-width: 767px) {
    #clients {
      width: 100%;
    }

    .row.row-centered,
    .row.row-between {
      flex-direction: column;
      align-items: center;
    }

    .row-logos img {
      height: 150px;
    }

    .row-logos img.half {
      height: 50px;
    }

    .row-logos img:not(:last-child) {
      margin-right: 0;
      margin-bottom: 4vw;
    }

    .subtitle {
      margin-bottom: 12vw;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) {

  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) {

  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {

  }

  /* Super large devices (large desktops, 1400px and up) */
  @media (min-width: 1400px) {

  }

</style>

<main id="clients">
  <h1 class="title">{title}</h1>
  <p class="subtitle margin-bottom-4vw">{@html subtitle}</p>
  <div class="row row-centered">
    <div class="container">
      {#each links as clients}
      <div class="row row-between row-logos">
        {#each clients as client}
        <img
          class={client.css || ''}
          src={client.imagePath}
          alt={client.name}
          title={client.name}
          aria-label={client.name} />
        {/each}
      </div>
      {/each}
    </div>
  </div>
</main>
